import React, { Component, useState } from 'react';
import { Form, Field } from 'react-final-form';

import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';
import FilledText from '../FilledText/FilledText';

const Step7 = (props) => { 
    return (
        <div>
          <h2>
            הסכמה  למסירת  מידע  מהמרשם  הפלילי ע"פ חוק המידע הפלילי ותקנת השבים, תשע"ט 2019
          </h2>

          <p>
          אני החתום/ה מטה <FilledText text={props.candidate.firstName + ' ' + props.candidate.lastName}/> מס' זהות <FilledText text={props.candidate.identityNumber}/> מועמד/ת לעבודה/ מועסק/ת ב {props.candidate.vendor ? <FilledText text={props.candidate.vendor.Value}/> : <FilledText text="לא צוין ספק"/> }  מצהיר/ה בזאת שידוע לי כי לצורך קבלתי לעבודה ו/או לצורך המשך העסקתי, עלי לעבור בדיקה ביטחונית.
          </p>

          <p>
          הואיל וכך, הנני נותן/ת בזאת הסכמתי מראש, על פי סעיפים 10 ו- 11 לחוק המידע הפלילי ותקנת השבים תשע"ט - 2019, כי יימסר לנציגכם המוסמך כל מידע המצוי אודותי במרשם הפלילי כמשמעותו בחוק זה.
          </p>

          <p>
          כמו כן, ולמען הסר הספק, הנני מוותר/ת בזאת מראש על קבלת הודעה בדבר מסירת המידע.
          </p>

          <p>
          כתב זה יעמוד בתוקפו בתהליכי בדיקת התאמתי לעבודה במסגרתכם ואם אתקבל לעבודה, וכל עוד אהיה מועסק/ת בתפקיד מסווג.
          </p>

          <br/><br/>

          <h4>
          אני מצהיר כי:
          </h4>

          <div className="custom-control custom-checkbox">
            <ValidatedCheckbox name="isApproveCriminalRecord" label="קראתי ואני מאשר את ההצהרה." validated={true} tabIndex="1"/>
          </div>
        </div>
    );
  };
  
  export default Step7;